import React from 'react';
import PropTypes from 'prop-types';

import Image from 'common/Image';
import logoBlack from 'images/logo-black.svg';

import { withIntlProvider } from 'modules/utils';
import FormFooter from './FormFooter';
import { MobileStyles } from '../styles';

import { locales } from '../locales';

const MobileWrapper = ({ children }) => {
	return (
		<MobileStyles>
			<Image
				dimensions={{
					height: '5.6rem',
					margin: '18px',
					justifySelf: 'self-start',
					alignSelf: 'center',
					gridArea: 'logo-image',
				}}
				source={logoBlack}
				altText="Lavu"
			/>
			{children}
			<FormFooter />
		</MobileStyles>
	);
};

MobileWrapper.propTypes = {
	children: PropTypes.node.isRequired,
};

export default withIntlProvider(locales)(MobileWrapper);
